import { useMemo } from "react";

import Highcharts from "highcharts";

import Stage from "@mapmycustomers/shared/types/entity/deals/Stage";
import { StageSummary } from "@mapmycustomers/shared/types/entity/deals/StageSummary";

export const useChartConfig = (
  funnelSummary: StageSummary[],
  chartTitle: string,
  onSelectStage: (stage: Stage) => void
): Highcharts.Options | undefined => {
  return useMemo<Highcharts.Options | undefined>(() => {
    if (!funnelSummary.length) {
      return undefined;
    }

    return {
      chart: {
        height: 350,
        plotShadow: false,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
        },
      },
      series: [
        {
          colorByPoint: true,
          data: funnelSummary.map((item) => ({
            custom: {
              stage: item.stage,
            },
            name: item.stage.name,
            y: item.totalDeals,
          })),
          events: {
            click: function (event) {
              const stage: Stage = event.point.options.custom?.stage; // click on a pie slice
              onSelectStage(stage);
            },
          },
          name: "# Deals",
          type: "pie",
        },
      ],
      title: {
        text: chartTitle,
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.y}</b>",
      },
    };
  }, [funnelSummary, onSelectStage, chartTitle]);
};

export default useChartConfig;
